/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import searchByProperty from 'cio/utils/search-by-property';

import AnalyticsService from 'cio/services/analytics';
import ApiErrorsService from 'cio/services/api-errors';
import TagModel from 'cio/models/tag';
import DS from 'ember-data';
import { sortByCaseInsensitive } from 'cio/utils/sort';

interface TagModalArgs {
  tags: TagModel[];
  onClose: () => void;
  disabled: boolean;
}

export default class TagModal extends Component<TagModalArgs> {
  @service analytics!: AnalyticsService;
  @service apiErrors!: ApiErrorsService;
  @service store!: DS.Store;

  @tracked search = '';
  @tracked deletingTag?: TagModel;
  @tracked editingTag?: TagModel;

  get sortedTags() {
    return sortByCaseInsensitive(this.args.tags, ['name']);
  }
  get filteredTags() {
    return searchByProperty(this.sortedTags, ['name'], this.search);
  }

  deleteTagTask = task(async (tag: TagModel) => {
    try {
      await tag.destroyRecord();
    } catch (err) {
      this.apiErrors.report(err);
    }

    this.deletingTag = undefined;
  });

  @action
  createNewTag() {
    this.analytics.track('tags', 'create_started');

    this.editingTag = this.store.createRecord('tag', { name: '' });
    this.search = '';
  }

  @action
  closeModal() {
    this.analytics.track('tags', 'manage_completed', { tags: this.args.tags });

    this.editingTag?.rollbackAttributes();

    this.args.onClose();
  }
}
